<!-- Rating Bar with Tooltips -->
<div class="rating-container">
   <!-- Tooltip 1 (Musaffa Score) -->
   <!-- Tooltip 1 (Musaffa) -->
   <div
      *ngIf="musaffaData?.iri_score != null && musaffaData.iri_score !== 0"
      class="rating_tooltip"
      [ngClass]="{
         below: isTooltipBelow
      }"
      [ngStyle]="{
         left:
            musaffaData.iri_score > 4.85
               ? 'calc(100% - 35px)'
               : musaffaData.iri_score * 20 + '%'
      }"
   >
      <div
         class="arrow"
         [ngClass]="{ below: !isTooltipBelow }"
         [ngStyle]="{
            left: getArrowPosition(musaffaData.iri_score)
         }"
      ></div>
      <div class="icon">
         <img src="../../../../assets/icons/iri-mus-logo.svg" />
      </div>
      {{ musaffaData.iri_score }}/5
   </div>

   <!-- Tooltip 2 (Community) -->
  <div
   *ngIf="
      communityData?.iri_score != null &&
      communityData.iri_score !== 0 &&
      (communityData.community_impact_and_reputation !== 0 ||
       communityData.human_rights_and_labor_practices !== 0 ||
       communityData.product_and_sector_involvement !== 0 ||
       communityData.environmental_responsibility !== 0 ||
       communityData.ethical_governance !== 0)
   "
   class="rating_tooltip"
   [ngClass]="{
      below: !isTooltipBelow
   }"
   [ngStyle]="{
      left:
         communityData.iri_score > 4.85
            ? 'calc(100% - 35px)'
            : communityData.iri_score * 20 + '%'
   }"
>
   <div
      class="arrow"
      [ngClass]="{ below: !isTooltipBelow }"
      [ngStyle]="{
         left: getArrowPosition(communityData.iri_score)
      }"
   ></div>
   <div class="icon blue">
      <img src="../../../../assets/icons/IconUser.svg" />
   </div>
   {{ communityData.iri_score }}/5
</div>

   <div class="segment_rating">
      <div class="segment">
         <span class="segment-label">Poor</span>
      </div>
      <div class="segment">
         <span class="segment-label">Weak</span>
      </div>
      <div class="segment">
         <span class="segment-label">Fair</span>
      </div>
      <div class="segment">
         <span class="segment-label">Good</span>
      </div>
      <div class="segment">
         <span class="segment-label">Excellent</span>
      </div>
   </div>
</div>

<!-- Bottom Labels -->
<div class="labels-bottom">
   <span>Poor</span>
   <span>Weak</span>
   <span>Fair</span>
   <span>Good</span>
   <span>Excellent</span>
</div>

<!-- Rating Explanation Accordion -->
<div ngbAccordion
   class="iri_score_accordion"
   [closeOthers]="true"
   [ngClass]="{ iri_score_accordion_active: isPanelOpen }"
>
   <div ngbAccordionItem="panel-0" [collapsed]="!isPanelOpen" (shown)="isPanelOpen = true" (hidden)="isPanelOpen = false" class="card">
      <div ngbAccordionHeader class="card-header">
         <button ngbAccordionButton class="btn-link">
            <h5>Score Interpretation Guide</h5>
         </button>
      </div>
      <div ngbAccordionCollapse>
         <div ngbAccordionBody class="card-body pt-3">
            <ng-template>
               <ul class="rating_point_list mb-0">
                  <li>
                     <span>Poor (0 - 1)</span> Indicates significant misalignment with
                     Islamic ethical and responsible investing principles.
                  </li>
                  <li>
                     <span>Weak (1 - 2)</span> Reflects limited adherence to key
                     ethical and social responsibility standards.
                  </li>
                  <li>
                     <span>Fair (2 - 3)</span> Shows moderate compliance with
                     responsible and Shariah-aligned practices, with room for
                     improvement.
                  </li>
                  <li>
                     <span>Good (3 - 4)</span> Demonstrates strong alignment with
                     ethical, social, and governance expectations.
                  </li>
                  <li>
                     <span>Excellent (4 - 5)</span> Exemplifies outstanding commitment
                     to Islamic values and responsible investment criteria.
                  </li>
               </ul>
            </ng-template>
         </div>
      </div>
   </div>
</div>

<!-- <ul class="rating_point_list">
    <li><span>Poor (0 - 1)</span> Indicates significant misalignment with Islamic ethical and
        responsible investing
        principles.</li>
        <li><span>Weak (1 - 2)</span> Reflects limited adherence to key ethical and social responsibility standards.
        </li>
        <li><span>Fair (2 - 3)</span> Shows moderate compliance with responsible and Shariah-aligned practices, with
            room
            for improvement.</li>
        <li><span>Good (3 - 4)</span> Demonstrates strong alignment with ethical, social, and governance expectations.
        </li>
        <li><span>Excellent (4 - 5)</span> Exemplifies outstanding commitment to Islamic values and responsible
            investment
            criteria.</li>
</ul> -->
